"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISO_8601_PATTERN = void 0;
exports.ISO_8601_PATTERN = '^d{4}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])$';
//# sourceMappingURL=dto.consts.js.map